export default function ErrorPage() {
  return (
    <div id="error-page">
      <h1>Oops!</h1>
      <p>Sorry, this url is not available.</p>
    </div>
  );
}
